import { render, staticRenderFns } from "./DashboardFeedbacks.vue?vue&type=template&id=2c8ed94a&scoped=true&"
import script from "./DashboardFeedbacks.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbacks.vue?vue&type=style&index=0&id=2c8ed94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ed94a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VChip,VDivider,VIcon,VProgressCircular})
